
import { useEffect } from 'react';

export default function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white">
      {/* Header */}
      <header className="border-b border-gray-700">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <h1 className="text-4xl font-bold mb-2">개인정보처리방침</h1>
          <p className="text-gray-400">최종 수정일: 2025년 1월 1일</p>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="space-y-12">
          {/* 서문 */}
          <section>
            <p className="text-gray-300 leading-relaxed">
              LEXO(이하 "회사")는 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관련 법령에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보처리방침을 수립·공개합니다.
            </p>
          </section>

          {/* 제1조 */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-teal-400">제1조 (수집하는 개인정보 항목)</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다.</p>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">1. 필수 수집 항목</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>이름, 이메일 주소, 연락처</li>
                  <li>서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보</li>
                </ul>
              </div>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">2. 선택 수집 항목</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>생년월일, 성별</li>
                  <li>일본어 학습 수준 및 관심사</li>
                </ul>
              </div>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">3. 결제 시 수집 항목</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>신용카드 정보, 은행계좌 정보 등 결제 수단 정보</li>
                  <li>결제 기록</li>
                </ul>
              </div>
            </div>
          </section>

          {/* 제2조 */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-teal-400">제2조 (개인정보 수집 및 이용 목적)</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">1. 서비스 제공</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>일본어 학습 콘텐츠 제공 및 맞춤형 서비스 제공</li>
                  <li>학습 진도 관리 및 피드백 제공</li>
                </ul>
              </div>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">2. 회원 관리</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>회원제 서비스 이용에 따른 본인확인, 개인 식별</li>
                  <li>불량회원의 부정 이용 방지와 비인가 사용 방지</li>
                  <li>가입 의사 확인, 연령확인, 불만처리 등 민원처리</li>
                </ul>
              </div>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">3. 마케팅 및 광고</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>신규 서비스 개발 및 맞춤 서비스 제공</li>
                  <li>이벤트 및 광고성 정보 제공 및 참여기회 제공</li>
                </ul>
              </div>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">4. 결제 및 환불</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>유료 서비스 이용 시 요금 결제 및 정산</li>
                  <li>환불 처리</li>
                </ul>
              </div>
            </div>
          </section>

          {/* 제3조 */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-teal-400">제3조 (개인정보 보유 및 이용 기간)</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">1. 회원 탈퇴 시</strong></p>
                <p>회원 탈퇴 즉시 파기. 단, 관련 법령에 따라 보존할 필요가 있는 경우 해당 기간 동안 보관</p>
              </div>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">2. 법령에 따른 보관</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)</li>
                  <li>대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)</li>
                  <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)</li>
                  <li>표시·광고에 관한 기록: 6개월 (전자상거래법)</li>
                  <li>웹사이트 방문 기록: 3개월 (통신비밀보호법)</li>
                </ul>
              </div>
            </div>
          </section>

          {/* 제4조 */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-teal-400">제4조 (개인정보 제3자 제공)</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>이용자가 사전에 동의한 경우</li>
                <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
                <li>통계작성, 학술연구나 시장조사를 위하여 특정 개인을 식별할 수 없는 형태로 제공하는 경우</li>
              </ul>
            </div>
          </section>

          {/* 제5조 */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-teal-400">제5조 (개인정보 처리 위탁)</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>회사는 서비스 향상을 위해 아래와 같이 개인정보 처리업무를 외부 전문업체에 위탁하여 운영하고 있습니다.</p>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">수탁업체 및 위탁업무 내용</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>결제 대행사: 결제 처리 및 정산</li>
                  <li>카카오톡: 메시지 발송 및 고객 상담</li>
                  <li>클라우드 서비스 제공업체: 데이터 보관 및 서버 운영</li>
                </ul>
              </div>
              <p>회사는 위탁계약 체결 시 개인정보보호법에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
            </div>
          </section>

          {/* 제6조 */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-teal-400">제6조 (정보주체의 권리·의무 및 행사방법)</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>개인정보 열람 요구</li>
                <li>오류 등이 있을 경우 정정 요구</li>
                <li>삭제 요구</li>
                <li>처리정지 요구</li>
              </ul>
              <p className="mt-4">권리 행사는 회사에 대해 서면, 전화, 전자우편 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.</p>
              <p>정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p>
            </div>
          </section>

          {/* 제7조 */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-teal-400">제7조 (개인정보 보호책임자)</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
              <div className="bg-gray-800 rounded-lg p-6 mt-4">
                <p className="mb-2"><strong className="text-white">개인정보 보호책임자</strong></p>
                <ul className="space-y-1">
                  <li>성명: LEXO 대표</li>
                  <li>이메일: lexojp.help@gmail.com</li>
                </ul>
              </div>
              <p className="mt-4">정보주체는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</p>
            </div>
          </section>

          {/* 제8조 */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-teal-400">제8조 (쿠키의 운영 및 거부)</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.</p>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">1. 쿠키의 사용 목적</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>이용자의 접속 빈도나 방문 시간 등을 분석</li>
                  <li>이용자의 취향과 관심분야를 파악 및 자취 추적</li>
                  <li>각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공</li>
                </ul>
              </div>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">2. 쿠키 설정 거부 방법</strong></p>
                <p>이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.</p>
                <p className="mt-2">단, 쿠키 설치를 거부할 경우 웹 사용이 불편해지며 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.</p>
              </div>
            </div>
          </section>

          {/* 제9조 */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-teal-400">제9조 (개인정보의 안전성 확보 조치)</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>회사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</p>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">1. 관리적 조치</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>내부관리계획 수립 및 시행</li>
                  <li>개인정보 취급 직원의 최소화 및 교육</li>
                </ul>
              </div>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">2. 기술적 조치</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>개인정보처리시스템 등의 접근권한 관리</li>
                  <li>접근통제시스템 설치</li>
                  <li>개인정보의 암호화</li>
                  <li>보안프로그램 설치 및 주기적 갱신·점검</li>
                </ul>
              </div>
              <div className="pl-6">
                <p className="mb-2"><strong className="text-white">3. 물리적 조치</strong></p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>전산실, 자료보관실 등의 접근통제</li>
                </ul>
              </div>
            </div>
          </section>

          {/* 제10조 */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-teal-400">제10조 (개인정보처리방침 변경)</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>이 개인정보처리방침은 2025년 1월 1일부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
            </div>
          </section>

          {/* 부칙 */}
          <section className="border-t border-gray-700 pt-8">
            <h2 className="text-xl font-bold mb-4">부칙</h2>
            <p className="text-gray-300">본 방침은 2025년 1월 1일부터 시행됩니다.</p>
          </section>

          {/* 문의 */}
          <section className="bg-gray-800 rounded-lg p-6">
            <h3 className="text-xl font-bold mb-4">문의하기</h3>
            <p className="text-gray-300 mb-4">
              개인정보처리방침에 대한 문의사항이 있으시면 아래 연락처로 문의해 주시기 바랍니다.
            </p>
            <div className="space-y-2 text-gray-300">
              <p><strong className="text-white">사업자명:</strong> LEXO</p>
              <p><strong className="text-white">사업자등록번호:</strong> 572-62-00804</p>
              <p><strong className="text-white">이메일:</strong> <a href="mailto:lexojp.help@gmail.com" className="text-teal-400 hover:text-teal-300">lexojp.help@gmail.com</a></p>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-700 mt-16">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <p className="text-center text-gray-400 text-sm">
            © 2025 LEXO. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
